export default () => ({
  index: [],
  uploadPercentage: 0,
});
